import Vue from 'vue'
import App from './App.vue'
import router from './router/router.js'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from './axios'
// 导入echarts 这边为了不麻烦 没有用vue-echarts
import * as echarts from 'echarts';

Vue.prototype.$echarts = echarts //挂载到Vue实例上面



Vue.config.productionTip = false
Vue.prototype.$http = axios

Vue.use(ElementUI)
new Vue({
  render: h => h(App),
  router:router   //  属性名字和值 一致,的话,等效于 router  只写一遍 ▶▶▶▶
}).$mount('#app')
